/* unplugin-vue-components disabled */import script from "./ProgressMarker.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProgressMarker.vue?vue&type=script&lang=ts&setup=true"

import "./ProgressMarker.vue?vue&type=style&index=0&id=12e193c2&lang=scss&scoped=true"

import exportComponent from "/builds/eb-football/footy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12e193c2"]])

export default __exports__